import React from 'react';
import { Alert } from '@mui/material';

const ErrorBanner = ({ message }) => {
  if (!message) return null;
  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {typeof message === 'string' ? message : String(message)}
    </Alert>
  );
};

export default ErrorBanner;
